module.exports = __webpack_public_path__ + "media/open2.284aac61.mp3";